"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require("prop-types");
var React = require("react");
var ReactDOM = require("react-dom");
var TableHeader = require("./TableHeader");
var TableRow = require("./TableRow");
var RV = require("react-virtualized/");
var SortDirection = RV.SortDirection;
var InnerTable = RV.Table;
var Column = RV.Column;
var AutoSizer = RV.AutoSizer;
var InfiniteLoader = RV.InfiniteLoader;
var _ = require("underscore");
var TableColumnChooser = require("./TableColumnChooser");

var ROW_HEIGHT = 20;
var ROW_HEIGHT_TOUCH = 25;

var MAX_COLUMNS = 15;
var COLUMN_FRACTION_BASE = 10000;
var MIN_COLUMN_PX_WIDTH = 30;

var HIGHLIGHT = {
  NONE: "none",
  SINGLE: "single",
  MULTI: "multi"
};

var Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      columnWidths: [],
      dragData: null,
      selectedIndexes: []
    }, _this.getDefaultColumnWidths = function (columns) {
      var pxWidth = _this.getPixelWidth();
      var numDynamicWeight = columns.filter(function (column) {
        return column.defaultWidth === undefined;
      }).length;
      var totalSetWidth = columns.reduce(function (result, column) {
        if (column.defaultWidth) {
          return result + column.defaultWidth;
        }
        return result;
      }, 0);
      var defaultWidth = (pxWidth - totalSetWidth) / numDynamicWeight / pxWidth;
      var result = columns.map(function (column) {
        if (column.defaultWidth !== undefined) {
          return column.defaultWidth / pxWidth;
        }
        return defaultWidth;
      });
      return _this.floatsToFraction(result, COLUMN_FRACTION_BASE);
    }, _this.floatsToFraction = function (floats, base) {
      var fractions = floats.map(function (float) {
        return Math.round(float * base);
      }).map(function (fraction) {
        return Math.max(1, Math.min(fraction, base));
      });
      var sum = fractions.reduce(function (total, fraction) {
        return fraction + total;
      }, 0);
      if (sum === base || floats.length === 0) {
        return fractions;
      }

      if (sum > base) {
        var _diffPerFraction = Math.floor((sum - base) / fractions.length);
        var _remainder = (sum - base) % fractions.length;
        return fractions.map(function (fraction, index) {
          var newFraction = fraction - _diffPerFraction;
          if (index >= fractions.length - _remainder) {
            return newFraction - 1;
          }
          return newFraction;
        });
      }

      // sum < base
      var diffPerFraction = Math.ceil((sum - base) / fractions.length);
      var remainder = (base - sum) % fractions.length;
      return fractions.map(function (fraction, index) {
        var newFraction = fraction - diffPerFraction;
        if (index >= fractions.length - remainder) {
          return newFraction + 1;
        }
        return newFraction;
      });
    }, _this.fractionsToFloat = function (fractions, base) {
      return fractions.map(function (fraction) {
        return fraction / base;
      });
    }, _this.getColumnResizeData = function (xPosition, event) {
      var relativePosition = xPosition / _this.getPixelWidth();
      var mousePosition = Math.max(0, Math.min(COLUMN_FRACTION_BASE, Math.round(COLUMN_FRACTION_BASE * relativePosition)));
      if (event.target.className.indexOf("resizeArea") === 0) {
        var dataKey = event.target.getAttribute("data-key");
        var index = _this.getColumnIndexOfDataKey(dataKey);
        return {
          first: _this.props.columns[index],
          second: _this.props.columns[index + 1],
          originalWidth: _this.state.columnWidths[index] + _this.state.columnWidths[index + 1],
          startPosition: mousePosition
        };
      }
      return false;
    }, _this.beginColumnResize = function (event) {
      var offset = _.nodeOffset(_this.refs.objectTable);
      var x = _.getClientPos(event).x - offset.left;
      var y = _.getClientPos(event).y - offset.top;
      if (_this.getColumnResizeData(x, event) === false || y > ROW_HEIGHT) {
        return;
      }

      document.addEventListener("mousemove", _this.resizeColumn);
      document.addEventListener("mouseup", _this.endColumnResize);

      event.preventDefault();
    }, _this.resizeColumn = function (event) {
      var offset = _.nodeOffset(_this.refs.objectTable);
      var x = _.getClientPos(event).x - offset.left;
      var data = _this.state.dragData ? _this.state.dragData : _this.getColumnResizeData(x, event);
      if (!data || typeof data === "string") {
        _this.setState({
          dragData: null
        });
        return;
      }

      var relativePosition = Math.round(x / _this.getPixelWidth() * COLUMN_FRACTION_BASE);
      var difference = relativePosition - data.startPosition;
      var firstIndex = _.findIndex(_this.props.columns, function (col) {
        return col.id === data.first.id;
      });
      var secondIndex = _.findIndex(_this.props.columns, function (col) {
        return col.id === data.second.id;
      });
      var firstWidth = _this.state.columnWidths[firstIndex] + difference;
      var secondWidth = _this.state.columnWidths[secondIndex] - difference;

      var MIN_WIDTH = Math.round(MIN_COLUMN_PX_WIDTH / _this.getPixelWidth() * COLUMN_FRACTION_BASE);
      if (firstWidth < MIN_WIDTH) {
        secondWidth = data.originalWidth - MIN_WIDTH;
        firstWidth = MIN_WIDTH;
      } else if (secondWidth < MIN_WIDTH) {
        firstWidth = data.originalWidth - MIN_WIDTH;
        secondWidth = MIN_WIDTH;
      }

      var newColumnWidths = [].concat(_this.state.columnWidths);
      newColumnWidths[firstIndex] = firstWidth;
      newColumnWidths[secondIndex] = secondWidth;
      data.startPosition = relativePosition;
      _this.setState({
        dragData: data
      });
      _this.columnWidthsChange(newColumnWidths);
    }, _this.endColumnResize = function () {
      document.removeEventListener("mousemove", _this.resizeColumn);
      document.removeEventListener("mouseup", _this.endColumnResize);

      if (!_this.state.dragData) {
        return;
      }

      // Catch any click events to prevent involuntary sorting
      document.addEventListener("click", _.stopPropagation, true);
      var CLICK_TIMEOUT = 30;
      window.setTimeout(function () {
        document.removeEventListener("click", _.stopPropagation, true);
      }, CLICK_TIMEOUT);

      // Clean up after resize
      _this.setState({ dragData: null });
    }, _this.getColumnIndexOfDataKey = function (dataKey) {
      return _.findIndex(_this.props.columns, { name: dataKey });
    }, _this.isFirstColumn = function (dataKey) {
      return _this.getColumnIndexOfDataKey(dataKey) === 0;
    }, _this.isLastColumn = function (dataKey) {
      return _this.getColumnIndexOfDataKey(dataKey) === _this.props.columns.length - 1;
    }, _this.onColumnDragStart = function (dataKey, evt) {
      // dataKey is dataKey of column
      var index = _this.getColumnIndexOfDataKey(dataKey);
      _.setDragData(evt.nativeEvent, "application/json", JSON.stringify(index));
      _this.setState({ dragData: JSON.stringify(index) });
    }, _this.onColumnDrop = function (dataKey, evt) {
      // dataKey, not index like it was in our own Table
      var index = _this.getColumnIndexOfDataKey(dataKey);
      var data = _.getDragData(evt.nativeEvent, "application/json");
      if (!data || data === "") {
        return;
      }

      var currentIndex = JSON.parse(data);
      if (currentIndex === -1) {
        // We dropped something which is not in the column list
        return;
      }
      evt.stopPropagation();
      if (index === currentIndex) {
        return;
      }
      _this.moveColumnToIndex(currentIndex, index);
    }, _this.moveColumnToIndex = function (from, to) {
      var columns = [].concat(_this.props.columns);
      var col = columns.splice(from, 1)[0];
      columns.splice(to, 0, col);
      var widths = [].concat(_this.state.columnWidths);
      var width = widths.splice(from, 1)[0];
      widths.splice(to, 0, width);

      _this.columnWidthsChange(widths);
      _this.onColumnChange(columns);
    }, _this.onSelect = function (index, rowData, event) {
      if (_this.props.highlight === HIGHLIGHT.NONE) {
        _this.props.onSelect(index, [index], event);
        return;
      }
      var newIndexes = _this.setSelected(index, event);
      _this.props.onSelect(index, newIndexes, event);
    }, _this.allowsMultiSelection = function () {
      return _this.props.highlight === HIGHLIGHT.MULTI;
    }, _this.setSelected = function (index, event) {
      var newSelection = [];
      if (index === false) {
        _this.setState({ selectedIndexes: newSelection });
        return newSelection;
      }

      if (_this.allowsMultiSelection() && event && _.isModKey(event)) {
        if (_this.isSelected(index)) {
          newSelection = _this.state.selectedIndexes.filter(function (selectedIndex) {
            return selectedIndex !== index;
          });
        } else {
          newSelection = _this.state.selectedIndexes.concat(index);
        }
      } else if (_this.allowsMultiSelection() && event && event.shiftKey) {
        var latestIndex = _this.state.selectedIndexes[_this.state.selectedIndexes.length - 1] || 0;
        var newSelectedIndexes = _.range(Math.min(index, latestIndex), Math.max(index, latestIndex) + 1);
        newSelection = _.union(_this.state.selectedIndexes, newSelectedIndexes);
      } else {
        // Simple click, make selection the clicked row.
        newSelection = [index];
      }

      if (index >= _this.state.firstIndex && index < _this.getLastVisibleIndex() - 1) {
        _this.setState({ selectedIndexes: newSelection });
        return newSelection;
      }

      _this.setState({ selectedIndexes: newSelection });
      return newSelection;
    }, _this.isSelected = function (index) {
      if (!_this.state.selectedIndexes) {
        return false;
      }
      return _this.state.selectedIndexes.indexOf(index) !== -1;
    }, _this.isHover = function (index) {
      if (_.isNullish(_this.props.hoverIndex)) {
        return false;
      }
      return _this.props.hoverIndex === index;
    }, _this.showColumnChooser = function () {
      var primaryColumns = _this.props.allColumns.filter(function (column) {
        return column.primary === true;
      });
      var primaryIds = primaryColumns.map(function (column) {
        return column.id;
      });
      var sortedPrimary = _.sortBy(primaryColumns, "name");
      var otherColumns = _this.props.allColumns.filter(function (column) {
        return column.primary !== true;
      });
      var sortedColumns = _.sortBy(otherColumns, "name");
      sortedColumns = sortedPrimary.concat(sortedColumns);

      var defaultSelected = sortedColumns.filter(function (column) {
        return _.pluck(_this.props.columns, "id").indexOf(column.id) !== -1;
      });
      defaultSelected = _.pluck(defaultSelected, "id");

      var updateColumns = function updateColumns(columnId, remove) {
        if (remove) {
          _this.removeColumn(parseInt(columnId, 10));
        } else {
          _this.addColumn(_.findWhere(sortedColumns, { id: parseInt(columnId, 10) }));
        }
      };
      var displayKey = _this.props.modalKey || undefined;
      var modal = React.createElement(TableColumnChooser, {
        logInfo: _this.props.log.info,
        language: _this.props.language,
        selectedColumns: defaultSelected,
        updateColumns: updateColumns,
        allColumns: sortedColumns,
        maxColumns: _this.props.maxColumns || MAX_COLUMNS,
        primaryIds: primaryIds
      });
      _this.props.presentModal(React.createElement(
        "div",
        null,
        modal
      ), displayKey, _this.props.language.get("dynamic_reserv_list_columns"));
    }, _this.removeColumn = function (columnId) {
      var columns = [].concat(_this.props.columns);
      var widths = [].concat(_this.state.columnWidths);
      var index = _.findIndex(columns, function (column) {
        return column.id === columnId;
      });
      var removedWidth = _this.state.columnWidths[index];
      if (index + 1 === widths.length) {
        widths[index - 1] = widths[index - 1] + removedWidth;
      } else {
        widths[index + 1] = widths[index + 1] + removedWidth;
      }
      widths.splice(index, 1);
      columns.splice(index, 1);
      _this.onColumnChange(columns);
      _this.columnWidthsChange(widths);
    }, _this.columnWidthsChange = function (newWidths) {
      _this.setState({
        columnWidths: newWidths
      });
      if (_this.props.onColumnWidthChange) {
        _this.props.onColumnWidthChange(_this.fractionsToFloat(newWidths, COLUMN_FRACTION_BASE));
      }
    }, _this.onColumnChange = function (newColumns) {
      if (_this.props.onColumnChange) {
        _this.props.onColumnChange(newColumns);
      }
    }, _this.addColumn = function (column) {
      var newColumns = _this.props.columns.concat(column);
      var widths = [].concat(_this.state.columnWidths);

      var MIN_WIDTH = COLUMN_FRACTION_BASE / MAX_COLUMNS;
      var requiredWidth = Math.max(widths[widths.length - 1] / 2, MIN_WIDTH);
      var newWidth = requiredWidth;

      // Take the required space from the closest columns without allowing
      // any column to be smaller than the minimum width.
      var index = widths.length - 1;
      while (requiredWidth > 0 && index >= 0) {
        var width = widths[index];
        if (width > MIN_WIDTH) {
          var widthToRemove = Math.min(width - MIN_WIDTH, requiredWidth);
          widths[index] = width - widthToRemove;
          requiredWidth = requiredWidth - widthToRemove;
        }
        index--;
      }

      widths.push(newWidth);
      _this.onColumnChange(newColumns);
      _this.columnWidthsChange(widths);

      if (_this.props.reload) {
        _this.props.reload();
      }
    }, _this.onPlusButtonClick = function () {
      if (_this.props.columns.length === 0) {
        return;
      }
      _this.showColumnChooser();
    }, _this.columnWithDataKey = function (dataKey) {
      return _.find(_this.props.columns, function (col) {
        return col.name === dataKey;
      });
    }, _this.getHeaderMenuItems = function (dataKey) {
      var column = _this.columnWithDataKey(dataKey);
      if (_this.props.columns.length === 1) {
        return [];
      }
      var hasSinglePrimaryColumn = _this.props.columns.filter(function (col) {
        return col.primary;
      }).length === 1;
      if (hasSinglePrimaryColumn && column.primary) {
        return [];
      }
      return [{
        key: "column.remove." + column.id,
        label: _this.props.language.get("dynamic_object_info_remove"),
        action: _this.removeColumn.bind(null, column.id)
      }];
    }, _this.clearSelection = function () {
      _this.setState({ selectedIndexes: [] });
    }, _this.selectAll = function () {
      var selectedIndexes = void 0;
      if (_this.state.selectedIndexes.length === _this.props.rowCount) {
        selectedIndexes = [];
      } else {
        selectedIndexes = _.range(0, _this.props.rowCount);
      }
      _this.setState({ selectedIndexes: selectedIndexes });
      _this.props.onSelect(0, selectedIndexes);
    }, _this.getRowMenuItems = function (indexes, refreshCallback) {
      if (!_this.props.getRowMenuItems) {
        return [];
      }
      return _this.props.getRowMenuItems(indexes, function () {
        var selectAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        // The invoked function may invoke the second parameter to clear the selection.
        _this.clearSelection();
        if (selectAll) {
          _this.selectAll();
        }
      }, refreshCallback);
    }, _this.rowRenderer = function (props) {
      var isHover = _this.isHover(props.index);
      var isSelected = _this.isSelected(props.index);
      if (isSelected || isHover) {
        if (props.rowData.color) {
          props.style.border = "1px dotted";
        } else if (isHover && !isSelected) {
          props.style.backgroundColor = "#f7f7f7";
        } else {
          props.style.backgroundColor = "#e3e3e3";
        }
      }
      if (props.rowData.textColor) {
        props.style.color = props.rowData.textColor;
      }
      if (props.rowData.color) {
        props.style.backgroundColor = props.rowData.color;
      }
      if (props.rowData.italicize) {
        props.style.fontStyle = "italic";
      }
      if (props.rowData.bold) {
        props.style.fontWeight = "bold";
      }
      if (props.rowData.textAlign === "right") {
        props.style.textAlign = "right";
      }

      return React.createElement(TableRow, _extends({
        onDragStart: _this.props.onDragStart,
        onSelect: _this.onSelect,
        getRowMenuItems: _this.getRowMenuItems,
        rowKey: props.key,
        onRowHover: _this.props.onRowHover,
        hoverButton: _this.props.hoverButton,
        contextMenu: _this.props.contextMenu
      }, props));
    }, _this.getCellRenderer = function (column, props) {
      if (props.cellRenderers && props.cellRenderers[column.id]) {
        return props.cellRenderers[column.id];
      }
      if (props.cellRenderers && props.cellRenderers["ALL"]) {
        return props.cellRenderers["ALL"];
      }
      return undefined;
    }, _this.headerRenderer = function (props) {
      return React.createElement(TableHeader, _extends({
        onDragStart: _this.onColumnDragStart,
        onDrop: _this.onColumnDrop,
        getHeaderMenuItems: _this.getHeaderMenuItems,
        isLastColumn: _this.isLastColumn,
        isFirstColumn: _this.isFirstColumn,
        rowCount: _this.props.rowCount,
        isSortable: _this.props.isSortable,
        contextMenu: _this.props.contextMenu
      }, props));
    }, _this.getPixelWidth = function () {
      var width = _this.props.width;
      if (_.isString(width)) {
        return _this.state.pixelWidth || 100;
      }
      if (!width && _this.table && _this.table.props.width) {
        return _this.table.props.width;
      }
      return width;
    }, _this.getPixelColumnWidths = function () {
      var totalWidth = 0;
      var componentWidth = _this.getPixelWidth();
      var pxWidths = _this.state.columnWidths.map(function (width, index, array) {
        if (index === array.length - 1) {
          return componentWidth - totalWidth;
        }

        var pxWidth = width > COLUMN_FRACTION_BASE ? COLUMN_FRACTION_BASE : Math.floor(width * componentWidth / COLUMN_FRACTION_BASE);
        totalWidth += pxWidth;
        return pxWidth;
      }, _this);
      var numCols = _this.props.columns.length;
      if (pxWidths.length < numCols) {
        var width = Math.floor(componentWidth / numCols);
        var remainder = componentWidth % numCols;
        var result = _this.props.columns.map(function (col, index) {
          if (index === numCols - 1) {
            return width + remainder;
          }
          return width;
        });
        return result;
      }
      return pxWidths;
    }, _this._loadTimeout = null, _this.loadMoreRows = function (_ref2) {
      var startIndex = _ref2.startIndex,
          stopIndex = _ref2.stopIndex;

      var timeout = 50;
      clearTimeout(_this._loadTimeout);
      _this._loadTimeout = setTimeout(function () {
        _this.props.loadMoreRows({ startIndex: startIndex, stopIndex: stopIndex });
      }, timeout);
    }, _this.reloadVisibleRows = function () {
      var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this._visibleRowStartIndex;

      _this.table.forceUpdateGrid();
      _this.loadMoreRows({
        startIndex: startIndex,
        stopIndex: _this._visibleRowStopIndex
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.columnWidths && this.props.columns || this.props.columnWidths.length !== this.props.columns.length) {
        this.setState({
          columnWidths: this.getDefaultColumnWidths(this.props.columns)
        });
      }
      if (this.props.setClearSelection) {
        this.props.setClearSelection(this.clearSelection);
      }
      if (this.props.registerSelectAll) {
        this.props.registerSelectAll(this.selectAll);
      }
      if (this.props.registerSetSelected) {
        this.props.registerSetSelected(this.setSelected);
      }
      if (this.props.registerReloadVisibleRows) {
        this.props.registerReloadVisibleRows(this.reloadVisibleRows);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var widthsSet = false;
      if (this.props.columnWidths && !_.isEqual(this.props.columnWidths, []) && !_.isEqual(this.props.columnWidths, this.state.columnWidths)) {
        if (this.props.columnWidths.length === this.props.columns.length) {
          var newWidths = this.floatsToFraction(this.props.columnWidths, COLUMN_FRACTION_BASE);
          if (!_.isEqual(newWidths, this.state.columnWidths)) {
            widthsSet = true;
            this.setState({
              columnWidths: newWidths
            });
          }
        }
      }
      if (!this.props.columnWidths && this.props.columns) {
        var _newWidths = this.getDefaultColumnWidths(this.props.columns);
        if (!_.isEqual(_newWidths, this.state.columnWidths)) {
          widthsSet = true;
          this.setState({ columnWidths: _newWidths });
        }
      }

      if (this.props.updatedIds !== prevProps.updatedIds) {
        this.updateLabels(this.props.defaultColumns, true);
        if (this.state.selectedIndexes.length > 0) {
          this.setState({ selectedIndexes: [] });
        }
      }

      if ((!this.state.columnWidths || this.state.columnWidths.length !== this.props.columns.length) && !widthsSet && this.props.columns.length > 0) {
        this.setState({
          columnWidths: this.getDefaultColumnWidths(this.props.columns)
        });
      }
      if (_.isString(this.props.width)) {
        var node = ReactDOM.findDOMNode(this);
        if (node && node.clientWidth !== this.state.pixelWidth) {
          this.setState({ pixelWidth: node.clientWidth });
        }
      }
    }

    // If a resize drag is detected, return the columns between which the drag is being performed

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var tableRowHeight = this.props.useTouch ? ROW_HEIGHT_TOUCH : ROW_HEIGHT;
      var columnWidths = this.getPixelColumnWidths();
      var addClasses = {
        settingsButton: true,
        disabled: this.props.columns.length === 0 || this.props.columns.length === MAX_COLUMNS
      };
      var plusButton = null;
      if (this.props.allColumns !== undefined && this.props.allColumns.length > 0) {
        plusButton = React.createElement(
          "div",
          {
            ref: "addButton",
            onClick: this.onPlusButtonClick,
            className: _.classSet(addClasses),
            title: this.props.language.get("nc_table_column_add_column")
          },
          "+"
        );
      }
      return React.createElement(
        "div",
        {
          ref: "objectTable",
          style: { flex: "1 1 auto" },
          onMouseDown: this.beginColumnResize
        },
        React.createElement(
          AutoSizer,
          { ref: "table" },
          function (_ref3) {
            var height = _ref3.height,
                width = _ref3.width;
            return React.createElement(
              InfiniteLoader,
              {
                ref: "loader",
                isRowLoaded: _this2.props.isRowLoaded,
                loadMoreRows: _this2.loadMoreRows,
                rowCount: _this2.props.rowCount
              },
              function (_ref4) {
                var _onRowsRendered = _ref4.onRowsRendered,
                    registerChild = _ref4.registerChild;
                return React.createElement(InnerTable, {
                  ref: function ref(table) {
                    _this2.table = table;
                    registerChild(table);
                  },
                  children: _this2.props.columns.map(function (column, index) {
                    var style = {};
                    if (column.textAlign) {
                      style.textAlign = column.textAlign;
                    }
                    return React.createElement(Column, {
                      label: column.name,
                      columnData: { style: style },
                      headerRenderer: _this2.headerRenderer,
                      cellRenderer: _this2.getCellRenderer(column, _this2.props),
                      width: columnWidths && columnWidths[index] ? columnWidths[index] : Math.round(1 / _this2.props.columns.length * 10000),
                      style: style,
                      dataKey: column.name
                    });
                  }),
                  onRowsRendered: function onRowsRendered(_ref5) {
                    var startIndex = _ref5.startIndex,
                        stopIndex = _ref5.stopIndex;

                    _this2._visibleRowStartIndex = startIndex;
                    _this2._visibleRowStopIndex = stopIndex;

                    _onRowsRendered({ startIndex: startIndex, stopIndex: stopIndex });
                  },
                  headerHeight: 21,
                  height: height,
                  rowCount: _this2.props.rowCount,
                  rowRenderer: _this2.rowRenderer,
                  rowGetter: _this2.props.getTableRow,
                  rowHeight: tableRowHeight,
                  width: width,
                  scrollToIndex: _this2.props.scrollToIndex,
                  sort: _this2.props.onSortingChanged // function, call when header is clicked {sortBy: string, sortDirection: SortDirection}
                  , sortBy: "" + _this2.props.sortColumn // String, column label, sorted by
                  , sortDirection: _this2.props.sortOrder === 0 ? SortDirection.ASC : SortDirection.DESC // SortDirection.ASC or SortDirection.DESC
                });
              }
            );
          }
        ),
        plusButton
      );
    }
  }]);

  return Table;
}(React.Component);

Table.HIGHLIGHT = HIGHLIGHT;

module.exports = Table;